<template>
  <table class="do-table do-table__user-employments"
         :class="{'do-table__user-employments--import': isSalaryIntegrationActive}">
    <thead>
    <th class="do-table__toggle-all" @click="$emit('toggleAllEmployments')">
      <template v-if="selectedEmploymentIds.length === 0">
        {{ $t('vue2.tagging.select_all') }}
      </template>
      <template v-else>
        {{ $t('vue2.tagging.unselect_all') }}
      </template>
    </th>
    <th>Navn</th>
    <th>Ansættelse</th>
    <th>Organisation</th>
    <th>Skabelon</th>
    <th class="td-subsalary">Vikarløn</th>
    <th>Std. Lønkode</th>
    <th>Std. Omkostningsted</th>
    </thead>

    <tbody ref="d-b">
    <!-- Integration-visning: grupperet pr. bruger -->
    <template v-if="isSalaryIntegrationActive" v-for="user in filteredUsers">
      <tbody :key="'user-' + user.id" class="user-group">
      <tr
        v-for="employment in user.v_employments"
        :key="'employment-' + employment.id"
        @click.stop="setTheEditUser(user)"
      >
        <!-- Checkbox pr. ANSÆTTELSE -->
        <td @click.stop="$emit('toggleEmployment', employment)">
          <div
            class="d-checkbox"
            :class="{'d-checkbox--active': isEmploymentSelected(employment.id)}"
            title="Vælg/fravælg ansættelse"
          />
        </td>

        <!-- Navn vises på alle rækker for overskuelighed -->
        <td :class="{'td-organisation': !employment.employment_template_id}"><strong>{{ user.name }}</strong></td>
        <td class="td-organisation">{{ employment.source_title ? employment.source_title : employment.title }}</td>
        <td class="td-organisation">{{ employment.organisation }}</td>

        <td>
              <span class="d-tag d-tag--inline"
                    v-if="employment.employment_template_id"
                    @click.stop="$emit('editEmployment', { user, employment })">
                {{ employment.title }}
              </span>
        </td>
        <td class="td-subsalary">
            <span class="do-pill do-pill--small do-custom-pill do-pill--yellow "
                  v-if="employment.manual_salary">Vikarløn
            </span>
        </td>
        <td>
          <span class="do-pill do-pill--small do-custom-pill" v-if="employment.manual_salary">
            {{ getDefaultSalaryCodeName(employment.salary_code_id) }}
          </span>
        </td>
        <td>
          <span class="do-pill do-pill--small do-custom-pill"
                v-if="employment.manual_salary && employment.default_omkostningssted">
            {{ getCostCenterName(employment.default_omkostningssted ) }}
          </span>
        </td>
      </tr>

      <tr v-if="user.v_employments.length === 0" @click.stop="setTheEditUser(user)">
        <td>
          <!-- Ingen ansættelser at vælge -->
        </td>
        <td><b>{{ user.name }}</b></td>
        <td colspan="5"></td>
      </tr>
      </tbody>
    </template>

    <!-- Simpel visning (uden integration) -->
    <template v-else>
      <tr v-for="user in filteredUsers" :key="user.id">
        <td colspan="1"></td>
        <td>{{ user.name }}</td>
        <td class="d-tags" colspan="5">
          <div class="d-tag"
               v-for="employment in user.v_employments"
               :key="employment.id"
               @click.stop="$emit('toggleEmployment', employment)">
            <span :class="{'d-checkbox': true, 'd-checkbox--active': isEmploymentSelected(employment.id)}"></span>
            {{ employment.title }}
            <div class="d-tag d-tag--inner" v-if="employment.organisation">{{ employment.organisation }}</div>
            <div class="do-pill do-pill--small do-pill--yellow" v-if="employment.manual_salary">Vikarløn</div>
          </div>
          <p class="italic font-small" v-if="user.v_employments.length === 0 && isShowNoEmploymentsText">Ingen
            ansættelser</p>
        </td>
      </tr>
    </template>
    </tbody>
  </table>
</template>

<script>
import AppToggle from '../../common/AppToggle.vue'

export default {
  components: {AppToggle},
  props: {
    filteredUsers: {
      default: () => []
    },
    selectedEmploymentIds: {
      type: Array,
      default: () => []
    },
    isShowNoEmploymentsText: {
      type: Boolean,
      default: false
    },
    isSalaryIntegrationActive: {
      type: Boolean,
      default: false
    },
    employmentTemplates: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    costCenters () {
      return this.$store.getters.costCenters
    },
    salaryCodes () {
      return this.$store.getters.salaryCodesSorted
    }
  },
  methods: {
    getCostCenterName (defaultOmkostningssted) {
      const costCenter = this.costCenters.find(costCenter => costCenter.code * 1 === defaultOmkostningssted)
      return costCenter ? costCenter.title : defaultOmkostningssted
    },
    getDefaultSalaryCodeName (salaryCodeId) {
      const salaryCode = this.salaryCodes.find(costCenter => costCenter.id === salaryCodeId)
      return salaryCode ? salaryCode.vTitle : salaryCodeId
    },
    setTheEditUser (user) {
      this.$emit('setTheEditUser', user)
    },
    isEmploymentSelected (employmentId) {
      return this.selectedEmploymentIds.indexOf(employmentId) > -1
    },
    setTbodyMaxHeight () {
      const tbody = this.$refs['d-b']
      if (!tbody) return
      const tbodyTop = tbody.getBoundingClientRect().top
      const windowHeight = window.innerHeight
      const maxHeight = windowHeight - tbodyTop - 20
      tbody.style.maxHeight = `${maxHeight}px`
    }
  },
  mounted () {
    this.setTbodyMaxHeight()
    window.addEventListener('resize', this.setTbodyMaxHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setTbodyMaxHeight)
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.salary-settings-users {
  background: #fff;
}

.do-table {
  border: 1px solid #e2e8f0;
  border-width: 0 1px 1px 1px;
  padding: 8px;
  width: 100%;
  background-color: #fff;
  border-collapse: collapse;
}

.do-table thead {
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  border-width: 1px 0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: 700;
  text-align: left;
  color: #8898aa;
  font-size: 10px;
}

.do-table thead th:first-child {
  cursor: pointer;
}

.do-table thead th,
.do-table tbody td {
  padding: 0.5rem 0.5rem;
}

.do-table thead th:first-child,
.do-table tbody td:first-child {
  width: 80px;
}

.do-table tbody tr:nth-child(2n),
.user-group:nth-child(2n) {
  background-color: #f9fafb;
}

.do-table tbody tr .icon__bg-circle {
  opacity: 0;
}

.do-table tbody tr:hover .icon__bg-circle {
  opacity: 1;
}

.do-table tbody {
  display: block;
  overflow-y: scroll;
  overscroll-behavior: contain;
}

.do-table thead,
.do-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}


.d-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem
}

.d-tag {
  display: flex;
  align-items: center;
  padding: 1px 5px;
  border-radius: 4px;
  color: #333;
  border: 1px solid #c8d6e2;
  background: #f6f9fc;
  font-size: 11px;
  font-weight: 500;
  transition: background-color .02s;
}

.d-tag.d-tag--inner {
  font-size: 9px;
  border-left: 1px solid #ccc;
  background: none;
  border-width: 0 0 0 1px;
  border-radius: 0;
  line-height: 10px;
  margin-left: 5px;
  font-weight: normal;
  color: #868686;
}

.d-tag:hover .d-tag.d-tag--inner {
  color: #222;
}

.do-table tbody tr:hover {
  cursor: pointer;
  background: aliceblue;
}

.do-table__toggle-all {
  color: #468ad7;
  font-weight: 700;
  text-transform: initial;
  user-select: none;
}

.do-table__toggle-all:hover {
  color: #3e4450;
}

.d-checkbox {
  position: relative;
  margin-left: 1rem;
  height: 12px;
  width: 12px;
  border: 1px solid var(--border-color);
  border-radius: 2px;
  padding: 2px;
}

.do-table.do-table__user-employments--import tr {
  background: transparent !important;
}

.do-table.do-table__user-employments--import tr:hover {
  background: aliceblue !important;
}

.d-checkbox.d-checkbox--active {
  background: var(--blue);
  border-color: var(--blue);
}

.d-checkbox:after, .d-checkbox:before {
  transform: rotate(40deg);
}

.d-checkbox.d-checkbox--active:before,
.d-checkbox.d-checkbox--active:after {
  background: #fff;
}

.d-checkbox:after {
  content: '';
  display: block;
  width: 2px;
  height: 8px;
  background: transparent;
  position: absolute;
  top: 1px;
  right: 3px;
}

.d-checkbox:before {
  content: '';
  display: block;
  width: 4px;
  height: 2px;
  background: transparent;
  position: absolute;
  bottom: 2px;
  right: 5px;
}

.do-table tbody tr td:first-child:hover .d-checkbox {
  box-shadow: 0 0 1px 2px #468ad791;
}

.do-table.do-table__user-employments:not(.do-table__user-employments--import) tr th:last-child,
.do-table.do-table__user-employments:not(.do-table__user-employments--import) tr td:last-child {
  width: 40px;
}

.do-pill--small {
  padding: 0 0.5rem;
  font-size: 10px;
  line-height: 16px;
  margin-left: 0.5rem;
}

.d-tag--inline {
  display: inline-flex;
}

.d-tag--inline:hover {
  box-shadow: 0 0 1px 2px rgba(70, 138, 215, .56863);
}

.user-group {
  border-bottom: 1px solid #eee;
}

.td-organisation {
  opacity: 0.7;
  font-size: 11px;
}

.toggle-flex {
  display: flex;
  align-items: center;
}

.toggle-flex--disabled {
  opacity: 0.15;
  cursor: not-allowed;
  background: transparent !important;
}

.input-group--flex {
  display: flex;
}

.do-custom-pill {
  padding: 0.25rem 0.5rem;
}

.td-subsalary {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// SalarySettingsUsersOpusTable.vue?64d75a32